<div class="wrapper cloud-biss-dialog">
    <div class="container-button">
        <button mat-button mat-dialog-close class="close-btn">
            <cqes-icon icon="close" class="close-icon"></cqes-icon>
        </button>
    </div>
    <div class="messageOnlyQES">
       <p> {{'manageTexts.messageOnlyQES' | translate}}</p>
       <p> {{'manageTexts.downloadBTMobile' | translate}}</p>      
       <div class="footer-content">
        <a href="https://play.google.com/store/apps/details?id=com.dais.software.mqes&hl=bg&gl=US"
          target="_blank" title="Google play">
          <span class="border-icon-app">
            <!-- google play -->
            <img src="../../../../../../assets/images/svg-icons/google-play-logo.svg">

          </span>
        </a>
        <a href="https://apps.apple.com/bg/app/b-trust-mobile/id1324004217" target="_blank" title="App Store">
          <span class="border-icon-app">
            <!-- app store -->
            <img src="../../../../../../assets/images/svg-icons/apps-apple-logo.svg">

          </span>
        </a>
        <a href="https://appgallery.huawei.com/app/C104500903" target="_blank" title="App Gallery">
          <span class="border-icon-app-g">
            <!-- appGallery -->

            <img src="../../../../../../assets/images/svg-icons/huawei-store-icon.svg">
          </span>
        </a>
      </div>
    </div>
</div>